import { useEffect, useState } from "react";
import { getWidget } from "../../../../helpers/widget_helper";
import classNames from "classnames";

const ExportTableNews = ({ source, name, data, type }) => {
  const [datas, setDatas] = useState(data ?? null);
  useEffect(() => {
    if (!data) {
      getWidget({ source }).then((res) => {
        setDatas(res);
      });
    }
  }, []);

  return (
    <div
      className={classNames({
        "d-flex justify-content-center": !data,
      })}
    >
    {datas?.length > 0 && (
      <table
        className={classNames({
          "table table-hover table-striped table-bordered w-75 mb-4": !data,
          "table-pdf-news-multiple-ranking": data,
        })}
      >
        <thead>
            {
              (type == "excel" && (
                <tr>
                  <td className="fw-bold text-center" colSpan={5}>
                    &nbsp;
                  </td>
                </tr>
              ))
            }
          <tr>
            <th className="fw-bold text-center" colSpan={5}>
              {name}
            </th>
          </tr>
          <tr>
            <th className="fw-bold text-center">No</th>
            <th className="fw-bold text-center">Judul</th>
            <th className="fw-bold text-center">Deskripsi</th>
            <th className="fw-bold text-center" colSpan={2}>
              Data
            </th>
          </tr>
        </thead>

        <tbody>
          {datas?.map((item, i) => (
            <>
              <tr>
                <td rowSpan={4}>{i + 1}</td>
                <td rowSpan={4}>{item.title}</td>
                <td rowSpan={4}>{item.description}</td>
                <td>Nama</td>
                <td>{item.author}</td>
              </tr>
              <tr>
                <td>Satuan Kerja</td>
                <td>{item.workunit}</td>
              </tr>
              <tr>
                <td>Jumlah View</td>
                <td>{item.total_views}</td>
              </tr>
              <tr>
                <td>Level</td>
                <td>{item.level}</td>
              </tr>
            </>
          ))}
        </tbody>
      </table>
    )}
    </div>
  );
};

export default ExportTableNews;
